import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class PDFViewerAPI extends ComponentAPI {
    /**
     * Returns the button theme.
     */
    getButtonTheme() {
        return this.state.buttonTheme;
    }
    /**
     * Sets the theme of the button.
     *
     * @param buttonTheme - The button theme.
     */
    setButtonTheme(buttonTheme) {
        this.setState({ buttonTheme });
    }
    /**
     * Returns the source of the PDF.
     */
    getSrc() {
        return this.state.src;
    }
    /**
     * Sets the source of the PDF.
     *
     * @param src - The source of the PDF.
     */
    setSrc(src) {
        this.setState({ src });
    }
    /**
     * Returns if the PDF viewer is visible.
     */
    isVisible() {
        return this.state.visible;
    }
    /**
     * Sets if the PDF viewer is visible.
     *
     * @param visible - If the PDF viewer is visible.
     */
    setVisible(visible) {
        this.setState({ visible });
    }
    /**
     * Returns if the PDF viewer is loading.
     */
    isLoading() {
        return this.state.loading;
    }
    /**
     * Sets if the PDF viewer is loading.
     *
     * @param loading - If the PDF viewer is loading.
     */
    setLoading(loading) {
        this.setState({ loading });
    }
    /**
     * Sets the download button expression.
     *
     * @param downloadPdfExpression - The download button expression.
     */
    setDownloadPdfExpression(downloadPdfExpression) {
        this.setState({ downloadPdfExpression });
    }
    /**
     * Returns the download button expression.
     */
    getDownloadPdfExpression() {
        return this.state.downloadPdfExpression;
    }
    /**
     * Returns the open PDF button expression.
     */
    getOpenPdfExpression() {
        return this.state.openPdfExpression;
    }
    /**
     * Sets the open PDF button expression.
     *
     * @param openPdfExpression - The open PDF button expression.
     */
    setOpenPdfExpression(openPdfExpression) {
        this.setState({ openPdfExpression });
    }
    /**
     * Returns the downloading PDF expression.
     */
    getDownloadingPdfExpression() {
        return this.state.downloadingPdfExpression;
    }
    /**
     * Sets the downloading PDF expression.
     *
     * @param downloadingPdfExpression - The downloading PDF expression.
     */
    setDownloadingPdfExpression(downloadingPdfExpression) {
        this.setState({ downloadingPdfExpression });
    }
    /**
     * Returns if the download PDF button is enabled.
     */
    getDownloadButtonEnabled() {
        return this.state.downloadButtonEnabled;
    }
    /**
     * Sets if the download PDF button is enabled.
     *
     * @param downloadButtonEnabled - If the download button is enabled.
     */
    setDownloadButtonEnabled(downloadButtonEnabled) {
        this.setState({ downloadButtonEnabled });
    }
    /**
     * Returns if the download PDF button is visible.
     */
    isShowDownloadButton() {
        return Boolean(this.state.showDownloadButton);
    }
    /**
     * Sets if the download PDF button is visible.
     *
     * @param showDownloadButton - If the download button is visible.
     */
    setShowDownloadButton(showDownloadButton) {
        this.setState({ showDownloadButton });
    }
}
export { PDFViewerAPI, };
//# sourceMappingURL=pdf-viewer-api.js.map